import {brickDefinitions} from "../Bricks/brick-definitions";

export default {
    mounted() {
        //Fix ensure proper initial element positioning before DnD kicks in
        const vm = this;
        const el = vm.$el;

        el.style.left = `${vm.x}px`;
        el.style.top = `${vm.y}px`;
    },
    data: () => ({
        brickDefinitions: brickDefinitions
    }),
    computed: {
        brickTypeName() {
            const vm = this;
            return vm.brickDefinitions[vm.type].name;
        }
    },
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
        type: {
            type: Number,
            required: true
        },
        x: {
            type: Number,
            required: true
        },
        y: {
            type: Number,
            required: true
        },
        config: {
            type: Object,
            required: true
        }
    }
};